/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetErrorMessages200ResponseInner,
} from '../models/index';
import {
    GetErrorMessages200ResponseInnerFromJSON,
    GetErrorMessages200ResponseInnerToJSON,
} from '../models/index';

/**
 * 
 */
export class ErrorMessagesApi extends runtime.BaseAPI {

    /**
     */
    async getErrorMessagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetErrorMessages200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/error-messages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetErrorMessages200ResponseInnerFromJSON));
    }

    /**
     */
    async getErrorMessages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetErrorMessages200ResponseInner>> {
        const response = await this.getErrorMessagesRaw(initOverrides);
        return await response.value();
    }

}
